import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { OnlineCitation } from "./Containers";
import Public from "./Layouts/Public";
import { useSendLog } from "./lib/hooks";

const AuthCallback = lazy(() => import("./Containers/AuthCallback"));
const Awards = lazy(() => import("./Containers/Awards"));
const Contact = lazy(() => import("./Containers/Contact"));
const Csl = lazy(() => import("./Containers/Csl"));
const ExtAuthCallback = lazy(() => import("./Containers/ExtAuthCallback"));
const Extensions = lazy(() => import("./Containers/Extensions"));
const AboutUs = lazy(() => import("./Containers/AboutUs"));
const jobsOpportunities= lazy(() => import("./Containers/JobsOpportunities"));
const Faq = lazy(() => import("./Containers/Faq"));
const Help = lazy(() => import("./Containers/Help"));
const HelpIndex = lazy(() => import("./Containers/HelpIndex"));
// const HelpIndexLib = lazy(() => import("./Containers/HelpIndexLib"));
// const HelpLib = lazy(() => import("./Containers/HelpLib"));
const Home = lazy(() => import("./Containers/Home"));
const Metadata = lazy(() => import("./Containers/Metadata"));
const Post = lazy(() => import("./Containers/Post"));
const PostIndex = lazy(() => import("./Containers/PostIndex"));
const PrivacyPolicy = lazy(() => import("./Containers/PrivacyPolicy"));
const Product = lazy(() => import("./Containers/Product"));
const Teachers = lazy(() => import("./Containers/Teachers"));
const Translator = lazy(() => import("./Containers/Translator"));
const Versions = lazy(() => import("./Containers/Versions"));
const WorkShop = lazy(() => import("./Containers/WorkShop"));
const WorkshopOrder = lazy(() => import("./Containers/WorkshopOrder"));
const WorkshopPayment = lazy(() => import("./Containers/WorkshopPayment"));
const WorkshopRegister = lazy(() => import("./Containers/WorkshopRegister"));
const WorkshopSubmit = lazy(() => import("./Containers/WorkshopSubmit"));
const Cloud = lazy(() => import("./Pages/Cloud"));
const Start = lazy(() => import("./Pages/Start"));
const Support = lazy(() => import("./Pages/Support"));
const page404 = lazy(() => import("./Pages/Page404"));
const GettingHelp = lazy(() => import("./Pages/GettingHelp"));
const SupportSite = lazy(() => import("./Pages/content/SupportSite"));
const QuickStartGuide = lazy(() => import("./Pages/QuickStartGuide"));
const Sync = lazy(() => import("./Pages/Sync"));
const creditsAndAcknowledgments = lazy(() =>
  import("./Pages/creditsAndAcknowledgments"),
);
const ConnectorPajoohyarUnavailable = lazy(() =>
  import("./Pages/ConnectorPajoohyarUnavailable.jsx"),
);

/**
 * Renders the application routes.
 * @returns {JSX.Element} The rendered Routes component.
 */
/**
 * Renders the application routes.
 * @returns {JSX.Element} The rendered Routes component.
 */
const Routes = () => {
  useSendLog();
  return (
    <Router>
      <Suspense fallback={<div></div>}>
        <Switch>
          <Public>
            <Switch>
              <Route exact path="/" component={Home} />
              <Route
                path="/auth-callback/:access_token/:expires_at"
                component={AuthCallback}
              />
              <Route
                path="/ext-auth-callback/:access_token/:expires_at"
                component={ExtAuthCallback}
              />
              <Route exact path="/blog/post/:post_id" component={Post} />

              <Route exact path="/blog" component={PostIndex} />
              <Route exact path="/help/:helpPost_id" component={Help} />
              <Route exact path="/help" component={HelpIndex} />
              <Route
                exact
                path="/help/category/:helpCategoryId"
                component={HelpIndex}
              />
              <Route path="/help-my-lib/:helpPost_id" component={Help} />
              <Route path="/help-my-lib/:search_term" component={HelpIndex} />
              <Route path="/help-my-lib" component={HelpIndex} />
              <Route path="/awards" component={Awards} />
              <Route path="/privacy-policy" component={PrivacyPolicy} />
              <Route path="/extensions" component={Extensions} />
              <Route path="/about-us" component={AboutUs} />
              <Route path="/jobs-opportunities" component={jobsOpportunities} />
              <Route path="/product" component={Product} />
              <Route path="/csl" component={Csl} />
              <Route path="/supported-sites" component={Translator} />
              <Route path="/metadata" component={Metadata} />
              <Route path="/contact" component={Contact} />
              <Route path="/faq" component={Faq} />
              <Route path="/versions" component={Versions} />
              <Route
                path="/workshop/register/detail/:workshop_id"
                component={WorkshopSubmit}
              />
              <Route
                path="/workshop/register/:workshop_id"
                component={WorkshopRegister}
              />
              <Route path="/workshop/order" component={WorkshopOrder} />
              <Route
                path="/workshops/payment/:workshop_id/:status"
                component={WorkshopPayment}
              />
              <Route exact path="/workshop" component={WorkShop} />
              <Route path="/teachers" component={Teachers} />
              <Route path="/cloud" component={Cloud} />
              <Route exact path="/cite/:token" component={OnlineCitation} />
              <Route exact path="/cite" component={OnlineCitation} />
              <Route exact path="/start_standalone" component={Start} />
              <Route exact path="/support" component={Support} />
              <Route exact path="/getting_help" component={GettingHelp} />
              <Route
                exact
                path="/content/support-site"
                component={SupportSite}
              />
              <Route
                exact
                path="/support/quick_start_guide"
                component={QuickStartGuide}
              />
              <Route exact path="/support/sync" component={Sync} />
              <Route
                exact
                path="/support/credits_and_acknowledgments"
                component={creditsAndAcknowledgments}
              />
              <Route
                exact
                path="/support/kb/connector_pajoohyar_unavailable"
                component={ConnectorPajoohyarUnavailable}
              />
              <Route component={page404} />
            </Switch>
          </Public>
        </Switch>
      </Suspense>
    </Router>
  );
};

export default Routes;
